GP.GPMod('MessagePane',function(self){
    var vent  = null;
    var _util = null;
    var _log  = null;
    var _duid = null;
    var _thread_json  = {};

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;
            //_log   = self.app.Util.log;

            data.reset();
        },
        reset: function() {
            _duid = null;
            _thread_json = {};
        }
    };

    var gui = {
        init: function() {
            // join moshpit for tracking
            MoshPit.join(self.$el);
            this.$count = self.$el.find('div.counter');
        }
    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":show", this.show);
            vent.on(self.moduleName+":reset", this.reset);
            vent.on('Nanoscroller:message-pane:setup', this.setup_nanoscroller);

            // request handler to check if the message pane is showing
            GP.reqres.setHandler('MessagePane:shown', this.message_pane_shown);

            // this is last init call to pop messages
            if (_msg_other_duid) {
                var promise = $.get('/members/msg/get_thread_json/', { duid: _msg_other_duid });
                promise.done(function(cb_data) {
                    vent.trigger('MessagePane.Inbox:load_thread_external', cb_data);
                });
            }


            vent.on(self.moduleName+":send_message",  this.send_message);
            vent.on(self.moduleName+":handle_bronze", this.handle_bronze);

        },
        message_pane_shown: function() {
            return !!MoshPit.is_shown('message-pane');
        },
        setup_nanoscroller: function() {
            self.$el.find(".nano").nanoScroller(_util.configs.nanoScroller);
        },
        show: function() {
            self.$el.show();
            vent.trigger(self.moduleName+'.Inbox:show');
        },
        update_count: function(count) {
            var msg_count = Number(count);
                msg_count = (msg_count == 'NaN') ? 0 : msg_count;

            // update div with count
            gui.$count.text(msg_count);

            if (msg_count > 0) {
                MoshPit.add_state(self.el + '-new-count');
            } else {
                MoshPit.remove_state(self.el + '-new-count');
            }
        },
        reset: function() {
            // close any open threads
            vent.trigger('ThreadLayout:close');
            vent.trigger('MessagePane.Inbox:reset');

            data.reset();
        },
        send_message: function(duid, tj) {
            // _duid = duid;
            _thread_json = tj;

            if (GP.sdata.my_user.membership == 'BRONZE') {
                events.handle_bronze(duid, tj);
                return;
            }

            // mobile gold_trial users redirect straight to billing, skip opening inbox/thread
            if (GP.sdata.is_mobile && _thread_json.threads && _thread_json.threads.length && _thread_json.threads[0].limit_reached) {
                window.location.replace('/members/billing/join/?sduid=' + duid);
                return;
            }

            vent.trigger('MessagePane.Inbox:load_thread_external', _thread_json);
        },
        handle_bronze: function(duid, tj, unlocked_cb) {
            // check if tj object data was passed into the function
            if (tj) {
                _thread_json = tj;
            }

            // first check unlocked status
            self.api.json('msg.get_unlocked_status', {
                data: {
                    duid: duid,
                }
            }).done(function(json) {
                // console.warn('handle_bronze get_unlocked_status json: ', json);
                // console.warn('handle_bronze get_unlocked_status _thread_json: ', _thread_json);

                // open thread normally if thread is already unlocked
                if (json && json.unlocked) {
                    // use supplied callback if provided (i.e. clicking thread-item-wrap from inbox)
                    if (typeof unlocked_cb === 'function') {
                        unlocked_cb();
                    } else {
                        vent.trigger('MessagePane.Inbox:load_thread_external', _thread_json);
                    }

                    data.reset();
                    return;
                }

                // open modal to spend/purchase credits if thread isn't unlocked
                vent.trigger('Modal:open', {
                    url: '/members/billing/unlock_thread_modal/',
                    duid: duid,
                    thread_json: _thread_json,
                    price: json.price,
                });

            }).fail(function() {
                // err msg?
            });
        },

    };

    this.addInitializer(function() {
        self.el  = 'message-pane';
        self.$el = $('#' + self.el);

        data.init();
        gui.init();
        events.init();
    });
});
